var components
try {
  components = {
    uDatetimePicker: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-datetime-picker/u-datetime-picker" */ "uview-ui/components/u-datetime-picker/u-datetime-picker.vue"
      )
    },
    qiunDataCharts: function () {
      return import(
        /* webpackChunkName: "uni_modules/qiun-data-charts/components/qiun-data-charts/qiun-data-charts" */ "@/uni_modules/qiun-data-charts/components/qiun-data-charts/qiun-data-charts.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 =
    _vm.currentRange === "custom"
      ? _vm.formatPickerDate(_vm.startDate) || "开始时间"
      : null
  var m1 =
    _vm.currentRange === "custom"
      ? _vm.formatPickerDate(_vm.endDate) || "结束时间"
      : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, item) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        item = _temp2.item
      var _temp, _temp2
      _vm.currentRange = item.value
    }
    _vm.e1 = function ($event) {
      _vm.showStartDatePicker = true
    }
    _vm.e2 = function ($event) {
      _vm.showEndDatePicker = true
    }
    _vm.e3 = function ($event) {
      _vm.showStartDatePicker = false
    }
    _vm.e4 = function ($event) {
      _vm.showEndDatePicker = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }